import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';
import { s as styles } from '../_notification-642118ea.js';

var bem = Bem('notification', styles);
var Notification = function Notification(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      extraClasses = _ref.extraClasses,
      closeProps = _ref.closeProps,
      toast = _ref.toast,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "extraClasses", "closeProps", "toast"]);

  return React.createElement("div", _extends({
    className: bem.b([appearance, {
      toast: toast
    }], extraClasses)
  }, rest), React.createElement("div", {
    className: bem.e('content')
  }, children), React.createElement("button", _extends({
    type: "button",
    className: bem.e('close')
  }, closeProps)));
};
Notification.displayName = 'Notification';
Notification.defaultProps = {
  appearance: null,
  closeProps: {},
  extraClasses: '',
  toast: false
};
Notification.propTypes = {
  /** Icon diisplayed in the notification message */
  appearance: PropTypes.oneOf([null, 'error', 'warning', 'success']),

  /** Content of the notification */
  children: PropTypes.node.isRequired,

  /** Props passed via spread operator to close icon */
  closeProps: PropTypes.object,
  // eslint-disable-line

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Lets Notification appear and disappear automatically */
  toast: PropTypes.bool
};
var notification = Injecss(Notification, styles);

export { notification as Notification };
